import $http from "../../axios";
import { Notification } from "element-ui";

const apiName = "/api/fecha-firme";

export async function fetchDateFirms({ commit, state }) {
  await $http
    .get(apiName, {
      params: state.tableDateFirms.params
    })
    .then(response => {
      commit("setDateFirms", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}
export async function fetchDteFirmSubscriber({ commit, state }) {
    await $http
        .get("/api/fecha-firme-subscriber")
        .then(response => {
            commit("setSubscriberDate", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function fetchDateFirmById({ commit }, id) {
  await $http
    .get(`${apiName}/${id}`)
    .then(response => {
      commit("setDateFirm", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function createDateFirm({ commit, state, dispatch }) {
  commit("setErrorForm", false);

  await $http
    .post(apiName, state.dateFirm)
    .then(response => {
       if (response.data.subscriber){
           commit("setSubscriberDate", response.data);
           Notification.success({
               title: "Success!",
               message: 'Se ha actualizado correctamente la fecha en firme del subscriptor',
               type: "success",
               duration: 1500,
               customClass: "notification-box"
           });
       }else{
           Notification.success({
               title: "Success!",
               message: 'Se ha creado correctamente el registro',
               type: "success",
               duration: 1500,
               customClass: "notification-box"
           });
           dispatch("fetchDateFirms");
       }

    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("setErrorForm", true);
    });
}
export async function updateDateFirmSubs({ commit, state, dispatch }) {
  commit("setErrorForm", false);

  await $http
    .post(apiName, state.dateFirm)
    .then(response => {
       if (response.data.subscriber){
           commit("setSubscriberDate", response.data);
           Notification.success({
               title: "Success!",
               message: 'Se ha actualizado correctamente la fecha en firme del subscriptor',
               type: "success",
               duration: 1500,
               customClass: "notification-box"
           });
       }else{
           Notification.success({
               title: "Success!",
               message: 'Se ha creado correctamente el registro',
               type: "success",
               duration: 1500,
               customClass: "notification-box"
           });
           dispatch("fetchDateFirms");
       }

    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("setErrorForm", true);
    });
}

export async function updateDateFirm({ commit, state, dispatch }) {
  commit("setErrorForm", false);

  await $http
    .put(`${apiName}/${state.dateFirm.id}`, state.dateFirm)
    .then(response => {
        Notification.success({
            title: "Success!",
            message: 'Se ha Actualizado correctamente el registro',
            type: "success",
            duration: 1500,
            customClass: "notification-box"
        });
      dispatch("fetchDateFirms");
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("setErrorForm", true);
    });
}

export async function deleteDateFirm({ commit, dispatch, state }, id) {
  await $http
    .delete(`${apiName}/${id}`)
    .then(response => {
      dispatch("fetchDateFirms");
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("setErrorForm", true);
    });
}



// WEBPACK FOOTER //
// ./src/modules/dateFirm/actions.js